import Tab from '@/components/Tab';

import styles from '@/styles/Tabsbar.module.css';

const Tabsbar = () => {
  return (
    <div className={styles.tabs}>
      <Tab icon="/logos/csharp_icon.svg" filename="home.cs" path="/" />
      <Tab icon="/logos/js_icon.svg" filename="about.js" path="/about" />
      <Tab icon="/logos/Java.svg" filename="contact.java" path="/contact" />
      <Tab icon="/logos/C++_icon.svg" filename="projects.cpp" path="/projects" />
      {/*<Tab
        icon="/logos/json_icon.svg"
        filename="articles.json"
        path="/articles"
      />*/}
      <Tab
        icon="/logos/markdown_icon.svg"
        filename="github.md"
        path="/github"
      />
    </div>
  );
};

export default Tabsbar;
